import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { Issue } from '../../IssueTrackerContext/types'
import { Permission } from '@cims-online/shared'
import { useRestoreIssueMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRestoreNotification } from 'hooks/notificationHandler'
import { useIssueTrackerContext } from '../../IssueTrackerContext'

export function useRestore(): RestoreRowActionOptions<Issue> {
  const { issues } = useIssueTrackerContext()
  const [restore] = useRestoreIssueMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreIssue: {
        issue: { formattedNumber },
      },
    }) => simpleRestoreNotification(formattedNumber),
  })
  return {
    permission: Permission.RemoveRestoreIssue,
    metadata: ({ deleted, deletedDate, deletedUser }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    default: 'active',
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      issues.refetch()
    },
  }
}
